// extracted by mini-css-extract-plugin
export default {"container":"ChangingIP_container__nV3Lp"};